import { createAsyncThunk } from "@reduxjs/toolkit";
import notify from "../../../components/notify";
import { t } from "i18next";
import { useGetData } from "../../../hooks/useGetData";
import {
  useInsertData,
  useInsertDataWithImage,
} from "../../../hooks/useInsertData";
import { useUpdateData, useUpdateDataWithImage } from "../../../hooks/useUpdateData";
import { useDeleteData } from "../../../hooks/useDeleteData";
import i18n from "../../../i18n/i18n";


export const getUserData = createAsyncThunk(
  "user/getUserData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await useGetData(`users/${id}`);
      const rawUser =
        response?.data?.data ||
        response?.data?.user ||
        response?.data ||
        response?.user ||
        response;

      if (rawUser && typeof rawUser === "object" && !Array.isArray(rawUser)) {
        const storedUser = JSON.parse(localStorage.getItem("user")) || {};
        const updatedUser = { ...storedUser, ...rawUser };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }
      return response;
    } catch (error) {
      const errorMessage =
        error.message === "Network Error"
          ? t("networkError")
          : error?.response?.data?.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const login = createAsyncThunk(
  "user/login",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`auth/login`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(t("networkError"), "error");
      }
      return rejectWithValue(error.message);
    }
  }
);
export const signup = createAsyncThunk(
  "user/login",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`auth/register`, data);
      return response;
    } catch (error) {
      const errorMessage =
        error.message === "Network Error"
          ? t("networkError")
          : error?.response?.data?.message;
      notify(errorMessage, "error");
      return rejectWithValue(errorMessage);
    }
  }
);
export const editUser = createAsyncThunk(
  "user/editUser",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await useUpdateDataWithImage(`users/${id}`, data);
      if (response?.data) {
        const storedUser = JSON.parse(localStorage.getItem("user")) || {};
        const updatedUser = { ...storedUser, ...response.data };
        localStorage.setItem("user", JSON.stringify(updatedUser));
      }
      return response;
    } catch (error) {
      const errorMessage =
        error.message === "Network Error"
          ? t("networkError")
          : error?.response?.data?.message;
      notify(errorMessage, "error");
      return rejectWithValue(errorMessage);
    }
  }
);

export const getReceptions = createAsyncThunk(
  "/userSlice/getReceptions",
  async () => {
    try {
      const response = await useGetData(`/users/reception/basic`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);